export default "__VITE_ASSET__DPhy13rp__"